import React, { FC, useContext, useEffect, useState } from 'react'
import CloseIcon from '../../../public/static/icons/close-white.svg'
import ArrowIcon from '../../../public/static/icons/arrow-right-white.svg'
import BannerPercentIcon from '../../../public/static/icons/banner-percent.svg'
import css from './Banner.module.scss'
import cx from 'classnames'
import { useLocalStorage } from '../../../hooks/useLocalStorage'
import { useForm } from 'react-hook-form'
import { requiredMessage } from '../../../lib/form'
import { useMutation } from '@apollo/client'
import {
  BANNER_SEND_FORM,
  DISMISS_PROMOCODE,
} from '../../../queries/bannerMutation'
import {
  sendPromocode,
  sendPromocodeVariables,
} from '../../../__generated__/sendPromocode'
import { dismissPromocode } from '../../../__generated__/dismissPromocode'
import LoadingIcon from '../../../public/static/icons/form-loader.svg'
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'
import { LayoutContext } from '../../../contexts/layoutProvider'

interface IBannerForm {
  email: string
}

const Banner: FC = () => {
  const [hide, setHide] = useLocalStorage('hide-banner', false)
  const [active, setActive] = useState(false)
  const [success, setSuccess] = useState(false)
  const [successMessage, setSuccessMessage] = useState(
    'На Вашу почту отправлен промокод',
  )
  const [error, setError] = useState('')
  const { register, errors, handleSubmit, reset } = useForm<IBannerForm>({
    mode: 'all',
  })
  const [sendPromocode, { loading }] = useMutation<
    sendPromocode,
    sendPromocodeVariables
  >(BANNER_SEND_FORM)
  const [dismissPromocode] = useMutation<dismissPromocode>(DISMISS_PROMOCODE)
  const { setCommonErrorMessage } = useContext(LayoutContext)
  const { executeRecaptcha } = useGoogleReCaptcha()

  useEffect(() => {
    if (!hide) {
      setTimeout(() => setActive(true), 1000)
    }
  }, [])

  const submit = async (values: IBannerForm) => {
    try {
      setError('')

      const token = await executeRecaptcha()
      const res = await sendPromocode({ variables: { ...values, token } })

      if (res?.data?.sendPromocode?.success) {
        setSuccessMessage(res.data.sendPromocode.message)
        setSuccess(true)

        setTimeout(() => {
          setSuccess(false)
          setHide(true)
          setActive(false)
          reset()
        }, 5000)
      } else {
        if (res.data.sendPromocode.message) {
          setCommonErrorMessage(res.data.sendPromocode.message)
          throw new Error(res.data.sendPromocode.message)
        } else {
          setCommonErrorMessage('Ошибка при отправке формы')
          throw new Error('Ошибка при отправке формы')
        }
      }
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <div className={cx(css.wrapper, active && css.active)}>
      <button
        type="button"
        className={css.close}
        onClick={() => {
          setActive(false)
          setHide(true)
          dismissPromocode()
        }}
      >
        <CloseIcon />
      </button>

      <p className={css.title}>Добро пожаловать!</p>
      <div className={css.suggestion}>
        <div className={css.percent}>
          <BannerPercentIcon />
        </div>
        <p>дарим скидку на&nbsp;первый заказ</p>
      </div>
      <p className={css.label}>
        укажите{' '}
        <a href="/info/policy" target="_blank">
          ваш e-mail
        </a>{' '}
        для получения скидки
      </p>

      {success ? (
        <p className={css.success}>{successMessage}</p>
      ) : (
        <>
          <form className={css.form} onSubmit={handleSubmit(submit)}>
            <input
              className={css.input}
              name="email"
              type="email"
              placeholder="mail@mail.ru"
              ref={register({
                required: requiredMessage,
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message: 'Некорректная почта',
                },
              })}
            />
            <button className={css.submit} type="submit">
              <ArrowIcon />
            </button>
          </form>
          {loading && <LoadingIcon className={css.loading} />}
        </>
      )}

      {errors?.email?.message && (
        <p className={css.error}>{errors.email.message}</p>
      )}

      {error && <p className={css.error}>{error}</p>}
    </div>
  )
}

export default Banner
